import { axios } from '@/lib/axios';
import { useMutation } from 'react-query';
import { MutationConfig } from '@/lib/react-query';

export type ConversationDTO = {
  agent_id?: string;
  user_id?: string;
  summary_mode?: string;
};

export type Conversation = {
  agent_id: string;
  conversation_id: string;
  start_time_unix_secs: number;
  call_duration_secs: number;
  message_count: number;
  status: 'initiated' | 'completed' | 'failed';
  call_successful: 'success' | 'failure';
  agent_name: string;
  transcript_summary: string;
  call_summary_title: string;
  direction: 'inbound' | 'outbound';
};

export type ConversationResponse = {
  conversations: Conversation[];
  has_more: boolean;
  next_cursor: string;
};

export const getConversations = ({
  agent_id,
  user_id,
  summary_mode,
}: ConversationDTO): Promise<ConversationResponse> => {
  return axios.get(`/chatbot/conversations`, {
    params: { agent_id, user_id, summary_mode },
  });
};

type UseConversationDetailsOptions = {
  config?: MutationConfig<typeof getConversations>;
};

export const useGetConversations = ({ config }: UseConversationDetailsOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getConversations,
  });
};
